import { render, staticRenderFns } from "./autoPayAds.vue?vue&type=template&id=513bdf7a&scoped=true"
import script from "./autoPayAds.vue?vue&type=script&lang=js"
export * from "./autoPayAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513bdf7a",
  null
  
)

export default component.exports